import { Header } from "./components/Header";
import * as styles from "./App.module.css";
import { useTrack } from "./hooks/useTrack";

const App = () => {
  console.log(styles);
  useTrack();

  return (
    <div className={styles.grid}>
      <Header />
      <section className={styles.intro}>
        <p className={styles.text}>
          Congratulations on completing your local program and becoming part of
          the global Atlantic Senior Fellow community! We are delighted you have
          received your Augmented Artifact and look forward to experiencing it
          together at the{" "}
          <a
            href="https://af-hub.org/topics/28042/page/virtual-welcome-ceremony"
            target="_blank"
            rel="noreferer"
          >
            Virtual Welcome Ceremony
          </a>{" "}
          on the 30th/31st of July.
        </p>
        <p className={styles.text}>
          Please bring the Augmented Artifact and a phone with you to the
          Virtual Welcome Ceremony. Senior Fellows from around the world have
          prepared an augmented reality experience to welcome you into this
          global community!
        </p>
        <p className={styles.text_small}>
          If you have questions about the Virtual Welcome Ceremony email:{" "}
          <a href="mailto:t.charles@atlanticfellows.org">
            t.charles@atlanticfellows.org
          </a>
        </p>
        <p className={styles.text_small}>
          If you have questions about the Augmented Artefact email:{" "}
          <a href="mailto:alice.wroe@atlanticfellows.org">
            alice.wroe@atlanticfellows.org
          </a>
        </p>
      </section>
      <section className={styles.faq}>
        <h1 className={styles.faqTitle}>FAQ</h1>
        <p className={styles.faqText}>Coming soon.</p>
      </section>
    </div>
  );
};

export default App;
